'use strict';

module.exports = {
  string: require('./string'),
  method: require('./method'),
  number: require('./number'),
  boolean: require('./boolean'),
  regexp: require('./regexp'),
  integer: require('./integer'),
  float: require('./float'),
  array: require('./array'),
  object: require('./object'),
  'enum': require('./enum'),
  pattern: require('./pattern'),
  email: require('./type'),
  url: require('./type'),
  date: require('./date'),
  hex: require('./type'),
  required: require('./required')
};


//////////////////
// WEBPACK FOOTER
// ./~/_async-validator@1.7.0@async-validator/lib/validator/index.js
// module id = 276
// module chunks = 0 1